<template>
  <div class="main">
    <Layout style="height:100vh;">
      <Header>
        <v-header></v-header>
      </Header>
      <Layout class="ivu-layout-has-sider" :class="{'overflow':$store.state.overflow,'overflow-visible':!$store.state.overflow}">
        <Sider v-show="sideShow" style="width:170px;min-width:170px;flex:1;max-width:170px;" hide-trigger>
          <v-sidebar style="overflow-y:auto;overflow-x:hidden"></v-sidebar>
        </Sider>
        <Content>
          <v-breadcrumb></v-breadcrumb>
          <div class="v-view" :style="$store.state.overflow?'overflow-y: auto;':''">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
            <Spin fix v-if="$store.state.showLoading"></Spin>
          </div>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import vHeader from "@/components/Header.vue";
import vSidebar from "@/components/SideBar.vue";
import vBreadcrumb from "@/components/BreadCrumb.vue";
export default {
  components: {
    vHeader,
    vSidebar,
    vBreadcrumb
  },
  data() {
    return {
      sideShow: true
    };
  },
  created() {
    if (this.$route.name == "Main" || this.$route.name == "Home") {
      this.sideShow = false;
    } else {
      this.sideShow = true;
    }
  },
  watch: {
    $route() {
      if (this.$route.name == "Main" || this.$route.name == "Home") {
        this.sideShow = false;
      } else {
        this.sideShow = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ivu-layout-header {
  background: inherit;
  padding: 0;
}
.ivu-layout-sider {
  background: #fff;
  border-right: 1px solid #d7dde4;
}
.ivu-layout-content {
  height: calc(100vh - 66px);
  background: #fff;
}
.ivu-layout.overflow > .ivu-layout-content {
  overflow-x: hidden;
}
.ivu-layout.overflow-visible > .ivu-layout-content {
  overflow-x: visible;
}
.v-view {
  height: calc(100vh - 100px);
  background: #fff;
  > .empty {
    padding: 10px;
  }
}
.ivu-input-group {
  width: 220px;
}
.demo-spin-icon-load {
  height: 100%;
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.ivu-table-cell-with-selection {
  padding-right: 0;
}
.ivu-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ivu-cascader-menu .ivu-cascader-menu-item {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellips span {
  font-size: 13px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>